import { Category } from '../models';

export class SetSelectedCategory {
    static readonly type = '[CATEGORY] SetCategory';

    constructor(public payload: Category) {}
}
